import { createAsyncAction } from "../../helpers/actions"
import { getCurrentUser } from "../api/getCurrentUser"
import { FETCH_CURRENT_USER } from "../constants/ActionTypes"

export const fetchCurrentUser = createAsyncAction<User | null>(
  FETCH_CURRENT_USER,
  getCurrentUser
)
